export default {

	init() {
		console.log('init nav...');
        document.addEventListener("DOMContentLoaded", this.bindEvents);
		document.addEventListener("DOMContentLoaded", this.searchDesktopArrow);
        
	},

	bindEvents() {
		if (!document.querySelector('.site-header')) {
			return;
		}

        const root = document.querySelector(':root');
        const header = document.querySelector('.site-header');
        const toggle = document.querySelector('.menu-toggle');
        const close = document.querySelectorAll('.menu-close');
        const menu = document.querySelector('.header-menu');
        const subnavElements = menu !== null ? menu.querySelectorAll('li.has-children') : null;
		const submenuClose = document.querySelectorAll('.submenu-close');
		const searchToggle = document.querySelector('.search-toggle');
		const searchClose = document.querySelector('.search-close');
		const searchOverlay = document.querySelector('.header-search');
        const delay = 300;
        let timer;

        Nav.root = root;
        Nav.header = header;
        Nav.navToggle = toggle;
        Nav.navMenu = menu;
        Nav.subnavElements = subnavElements;
		Nav.searchOverlay = searchOverlay;
		Nav.searchToggle = searchToggle;
        Nav.delay = delay;
        Nav.timer = timer;

        if(menu !== null) {
            // Mobile menu toggles
            toggle.addEventListener('click', Nav.toggleNav);
    		close.forEach(elem => {
    			elem.addEventListener('click', Nav.closeNav);
    		});

            // Mobile subnavs and desktop dropdowns
            subnavElements.forEach(elem => {
                var subnavToggle = elem.querySelector(':scope > a');
                var subnavParent = elem;

                subnavToggle.addEventListener('click', Nav.toggleSubnav);

                // Desktop hover events
                // subnavParent.addEventListener('mouseenter', function(e) {
                //     var submenu = subnavParent.querySelector(':scope > .submenu');
                //     var isMobile = Nav.navToggle.checkVisibility();

                //     clearTimeout(Nav.timer);

                //     if(!submenu || isMobile) {
                //         return;
                //     }

                //     Nav.timer = setTimeout(function() {
                //         Nav.openSubnav(subnavToggle, submenu);
                //     }, Nav.delay);
                // });
                // subnavParent.addEventListener('mouseleave', function(e) {
                //     var submenu = subnavParent.querySelector(':scope > .submenu');
                //     var isMobile = Nav.navToggle.checkVisibility();

                //     clearTimeout(Nav.timer);

                //     if(!submenu || isMobile) {
                //         return;
                //     }

                //     Nav.timer = setTimeout(function() {
                //         Nav.closeSubnav(subnavToggle, submenu);
                //     }, Nav.delay);
                // });
            });
    		submenuClose.forEach(elem => {
    			elem.addEventListener('click', Nav.closeAllSubnavs);
    		});

			// Desktop accordion hover
			Nav.bindAccordionEvents();
        }

        if(searchToggle !== null) {
    		// Search overlay
    		searchToggle.addEventListener('click', Nav.toggleSearch);
    		searchClose.addEventListener('click', Nav.closeSearch);
        }

        // Fixed header
        window.addEventListener('scroll', Nav.navFixedState);
    },

    // Mobile nav

    toggleNav(e) {
        if (Nav.navMenu.classList.contains('is-open')) {
            Nav.closeNav();
        } else {
            Nav.openNav();
        }
    },

    openNav() {
        document.querySelector('html').classList.add('is-nav-open');
        Nav.navMenu.classList.add('is-open');
        Nav.navToggle.setAttribute('aria-expanded', 'true');

        // Listen for resize and close menus
        window.addEventListener('resize', Nav.navState, false);
    },

    closeNav() {
        document.querySelector('html').classList.remove('is-nav-open');
        Nav.navMenu.classList.remove('is-open');
        Nav.navToggle.setAttribute('aria-expanded', 'false');

        // Stop listening for resize
        window.removeEventListener('resize', Nav.navState, false);
    },

    // Submenus

    toggleSubnav(e) {
        e.preventDefault();
        var toggle = e.currentTarget;
        var parent = toggle.parentElement;
        var submenu = (parent) ? parent.querySelector(':scope > .submenu') : null;

        if (!toggle || !submenu) {
            return;
        }

        if (submenu.classList.contains('is-open')) {
            Nav.closeSubnav(toggle, submenu);
        } else {
            Nav.openSubnav(toggle, submenu);
        }
    },

    openSubnav(toggle, submenu) {
        if (!toggle || !submenu) {
            return;
        }

        Nav.closeAllSubnavs();

        toggle.setAttribute('aria-expanded', 'true');
        toggle.classList.add('is-active');
        submenu.classList.add('is-open');
		submenu.classList.remove('is-closed');

        document.addEventListener('click', Nav.navClickOutside);
        document.addEventListener('keyup', Nav.escapeListener);
    },

    closeSubnav(toggle, submenu) {
        if (!toggle || !submenu) {
            return;
        }

        toggle.setAttribute('aria-expanded', 'false');
        toggle.classList.remove('is-active');
        submenu.classList.remove('is-open');
		submenu.classList.add('is-closed');
    },

    closeAllSubnavs() {
        if(Nav.subnavElements) {
            Nav.subnavElements.forEach(elem => {
                var toggle = elem.querySelector(':scope > a');
                var submenu = elem.querySelector(':scope > .submenu');

                Nav.closeSubnav(toggle, submenu);
            });

            document.removeEventListener('click', Nav.navClickOutside);
            document.removeEventListener('keyup', Nav.escapeListener);
        }
    },

	// Search overlay

	openSearch() {
		Nav.searchOverlay.classList.add('is-open');
		Nav.searchToggle.setAttribute('aria-expanded', 'true');
		Nav.searchOverlay.querySelector('input').focus();
		document.addEventListener('keyup', Nav.escapeListener);
	},

	closeSearch() {
		Nav.searchOverlay.classList.remove('is-open');
		Nav.searchToggle.setAttribute('aria-expanded', 'false');
		Nav.searchOverlay.querySelector('input').blur();
		document.removeEventListener('keyup', Nav.escapeListener);
	},

	toggleSearch(e) {
		if(Nav.searchOverlay.classList.contains('is-open')) {
			Nav.closeSearch();
		} else {
			Nav.openSearch();
		}
	},

    // Event helpers

    navFixedState() {
        const hero = document.querySelector('.page-header') ? document.querySelector('.page-header') : document.querySelector('.page-hero');
        let threshold = Nav.header.offsetHeight;

        if(hero) {
            threshold += hero.offsetHeight;
            threshold += parseInt(window.getComputedStyle(hero).getPropertyValue('margin-top'));
        }

        Nav.scrollPreviousY = window.scrollY;
        Nav.closeAllSubnavs();

        if (Nav.scrollPreviousY > threshold) {
            Nav.root.classList.add('has-header-fixed');
            Nav.header.classList.add('is-header-fixed');
        } else {
            Nav.root.classList.remove('has-header-fixed');
            Nav.header.classList.remove('is-header-fixed');
        }
    },

    navState() {
        Nav.closeNav();
        Nav.closeAllSubnavs();
		Nav.closeSearch();
    },

    navClickOutside(e) {
        if (!Nav.navMenu.contains(e.target)) {
            Nav.closeAllSubnavs();
        }
    },

    escapeListener(e) {
        if(e.key && e.key === 'Escape') {
            Nav.closeAllSubnavs();
			Nav.closeSearch();
        }
    },

    searchDesktopArrow() {
        $('#search-desktop').on('keyup', function(){
            $('#search-desktop-wrapper').addClass('has-value');
            console.log('keyup');
        });

        $('#search-desktop-wrapper .submit-arrow, #search-mobile-wrapper .submit-arrow').on('click', function(){
            $(this).closest('form').submit();
        });
    },

	bindAccordionEvents() {
		let $accordions = $(Nav.subnavElements).find('.accordion-list');
		if(!$accordions.length) {
			return;
		}
		$accordions.each(function() {
			let isAccordionGroup = this.hasAttribute('data-accordion-group');
			let firstItemActive = true;
			let $items = $(this).find('.accordion-item');
			$items.each(function(index, element) {
				let elem = this;
				let $trigger = $(this).find('[data-accordion]');
				elem.addEventListener('mouseenter', function(e) {
					let isMobile = Nav.navToggle.checkVisibility();
					if(isMobile) {
						return;
					}
					if($trigger.attr('aria-expanded') !== 'true') {
						Accordion.toggleVisibility($trigger[0]);
					}

				});
				// Mouseout is only needed if accordion is not a group
				if(isAccordionGroup !== true) {
					elem.addEventListener('mouseleave', function(e) {
						let isMobile = Nav.navToggle.checkVisibility();
						if(isMobile) {
							return;
						}
						Accordion.toggleVisibility($trigger[0]);
					});
				}
				// Set first accordion to active by default
				if(firstItemActive && index == 0) {
					let isMobile = Nav.navToggle.checkVisibility();
					if(!isMobile) {
						Accordion.toggleVisibility($trigger[0]);
					}

				}
			});
		});
	}

};
